import { queryHashTail } from './bootRedirectQuery.js'

// The comm host's route lockdown (comm.symbols.app — docs/COMM_HOST.md).
//
// smbls router guard, registered beside demoRouteGuard in context.js
// (`true` allows, `false` cancels, a string redirects in-router). It runs
// INSIDE the router before pushState/content-set, so a route the comm host does
// not serve never mounts here — no canvas home, no studio, no app page:
//   • `/` (the workspace home)  → the comm home (`/chat`);
//   • a served route (shared commProfileData.js `commRoutes`) → allowed;
//   • any other route → the SAME path on the workspace host of this tier
//     (`dev.comm.symbols.app/files` → `dev.my.symbols.app/files`), a full
//     cross-origin load through shared `openOnWorkspaceHost`, and the
//     navigation here is cancelled. On a simulated comm host (`?comm=1` on a
//     workspace host) there is no other host, so it lands on the comm home.
// Not a comm host → a no-op.
//
// The comm functions are read through `element.call` (registered by the
// shared functions barrel), the query + hash ride along like demoRouteGuard's.
export const commRouteGuard = ({ pathname, element, query, hash }) => {
  const call = element && typeof element.call === 'function' ? element.call.bind(element) : null
  if (!call || !call('isCommHost')) return true
  const path = String(pathname || '/')
  if (call('isCommRoute', path)) return true
  const tail = queryHashTail(query, hash)
  const home = call('commHome') + tail
  const bare = call('stripWorkspacePrefix', path.split(/[?#]/)[0]) || '/'
  if (bare === '/') return home
  if (call('openOnWorkspaceHost', element, path + tail)) return false
  return home
}
